var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.185 -1.123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.488,0A27.5,27.5,0,1,1,8.052,8.054,27.5,27.5,0,0,1,27.488,0ZM43.751,11.226a23.006,23.006,0,1,0,6.711,16.264,23.006,23.006,0,0,0-6.711-16.264Z",
    transform: "translate(1.188 1.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.683 9.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.5,143.863l-7.387-7.387h-7.189v-4.141h7.244a2.045,2.045,0,0,0,0-4.09h-7.244v-1.951a2.073,2.073,0,0,0-1.987-2.087,2.045,2.045,0,0,0-2.1,2.044V139.2a1.363,1.363,0,0,0,1.363,1.363h8.221l6.189,6.189a2.045,2.045,0,1,0,2.892-2.892Z",
    transform: "translate(-172.687 -115.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.235,
    cy: 3.235,
    r: 3.235,
    transform: "translate(7.421 6.296) rotate(-76.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.849,208.434a9.212,9.212,0,1,1-12.142-12.807v-2.241a11.257,11.257,0,1,0,13.63,16.535Z",
    transform: "translate(-47.602 -179.552)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType2);
export default __webpack_public_path__ + "static/media/aioa-icon-type-2.dbd38b9c8214777ac6a51e796c53d1b1.svg";
export { ForwardRef as ReactComponent };